var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.fadeOut)?_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"hmt-preloader"},[_c('div',{staticClass:"hmt-preloader__container"},[_c('LoaderIcon')],1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }